import React, { Component, createContext } from "react";
import { matchPath } from "react-router";

import Main from "./Layout/main";

export const MainContext = createContext();

class MainProvider extends Component {
  state = {
    homepage: true,
    reset: false,
    bit: null,
    subp: null,
    lengg: null,
    usages: null
  };

  mainToggle = number => {
    this.setState({
      homepage: false,
      bit: `${number}`
    });
  };
  subSet = thing => {
    this.setState({
      subp: `${thing}`
    });
  };
  usageSet = type => {
    this.setState({
      usages: `${type}`
    });
  };
  lengSet = size => {
    this.setState({
      lengg: `${size}`
    });
  };

  popularToggle = () => {
    this.setState({
      homepage: false
    });
  };

  flipTheSwitch = () => {
    this.setState({
      reset: true
    });
  };

  render() {
    const path = matchPath(window.location.pathname, {
      path: "/:bits/:usage/:leng/"
    });
    let set = null;
    let bitt = this.state.bit;
    let typp = this.state.subp;
    let usage = this.state.usages;
    let leng = this.state.lengg;
    if (path != null) {
      set = path.params;
      const bitSplit = set.bits.split("-");
      bitt = bitSplit[0];
      typp = bitSplit[1];
      usage = set.usage;
      leng = set.leng;
    }

    return (
      <MainContext.Provider
        value={{
          homepage: this.state.homepage,
          mainToggle: this.mainToggle,
          popularToggle: this.popularToggle,
          reset: this.state.reset,
          flipTheSwitch: this.flipTheSwitch,
          bit: bitt,
          usageSet: this.usageSet,
          usages: usage,
          setLeng: this.lengSet,
          lengs: leng,
          subSet: this.subSet,
          subp: typp
        }}
      >
        {this.props.children}
      </MainContext.Provider>
    );
  }
}

class App extends Component {
  render() {
    return (
      <MainProvider>
        <Main />
      </MainProvider>
    );
  }
}

export default App;
